import React, { useState, useEffect } from 'react';
import Moment from 'react-moment';

const Tag = (props) => {
  let relDoc = props.relatedDocument;
  let theme = props.theme;
  return (
  <div className={"btn btn-xs upcoming-action-tag " + theme} 
      onClick={()=>window.open("form/" + relDoc.documentId, "_self")}>
      {relDoc.name}
  </div>)
};

const TimelineEvent = (props) => {
    let defaults = {
      "historyDesc": "Error",
      "historyType": "Error",
      "historyIcon": "fa-error",
      "historyTime": "",
      "notes": "",
      "historyDocs": "",
      "historyURL": "",
      "historyURLDesc": "",
      "historyOpensOverlay": false,
      "documentId": "",
      "extraData": {}
    }
  
    let event = Object.keys(defaults).reduce((c: any, k) => {
      let field = props.event[k] ? props.event[k] : defaults[k];
      c[k] = field;
      return c;
    }, {});
  
    let iconSet = {
      "Stage Change"        : 'fa-star',
      "Confidence Change"   : 'fa-star',
      "Email Read"          : 'fa-envelope-open',
      "Email Click Link"    : 'fa-envelope',
      "Action Call"         : 'fa-phone',
      "Action Email"        : 'fa-envelope',
      "Action Presentation" : 'fa-video-camera',
      "Action Other"        : 'fa-question',
      "Action Cancelled"    : 'fa-ban',
      "Discovery"           : 'fa-search',
      "Budget"              : 'fa-wallet',
      "Order"               : 'fa-shopping-cart'
    }

    var iconId = iconSet[event.historyType] || 'fa-question';
    
    let icon = <i class={`fa ${iconId}`} style={event.historyType === 'Action Cancelled' ? {"color":'#d9534f'} : {}} />;

    const calendarStrings = {
      lastDay : '[Yesterday at] LT',
      sameDay : '[Today at] LT',
      nextDay : '[Tomorrow at] LT',
      lastWeek : '[last] dddd [at] LT',
      nextWeek : 'dddd [at] LT',
      sameElse : 'L'
  };
    
    let time = event.extraData?.collated ? ( 
      <div className="timeline-event-time">
          <Moment calendar={calendarStrings} date={event.historyTime} /> to <Moment calendar={calendarStrings} date={event.extraData.timeEnd} />
      </div> 
      ) : ( 
        <div className="timeline-event-time">
          <Moment calendar={calendarStrings} date={event.historyTime} />
        </div> 
      );
  
    let url = event.historyURL.length && event.historyURLDesc.length && event.historyURL !== ("form/" + props.currentDocId) ?
      (
        <a href={event.historyURL}>
          <i class="fa fa-link"></i> {event.historyURLDesc}
        </a>
      ) :
      (<div />);
  
    let tags = event.historyDocs.map( d => <Tag relatedDocument={d} theme="btn-default" /> )

    let eventNotesComponents = []
    if ( event.notes.length > 0 )
    {
        event.notes.split( "\n" ).forEach( l => { eventNotesComponents = eventNotesComponents.concat( [l, <br/>] ) } );
        
        if ( eventNotesComponents.length > 10 )
        {
          let totalLines = eventNotesComponents.length / 2;
          eventNotesComponents = eventNotesComponents.slice( 0, 10 );
          eventNotesComponents = eventNotesComponents.concat( [<b>... {totalLines - 10} More Lines</b>] )
        }
    }

    let body = (eventNotesComponents.length ? (
      <div className="timeline-event-body">
        {tags}
        <div className="well well-sm">
            {eventNotesComponents}
        </div>
      </div>
    ) : (<div className="timeline-event-body">{tags}</div>));
    
    let shouldOpenOverlay = event.historyOpensOverlay && event.documentId !== props.currentDocId;
    let eventTitle = shouldOpenOverlay ? (
      <a href={ "/form/" + event.documentId }>{ event.historyDesc }</a>
    ) : (
      <>{ event.historyDesc }</>
    );

    //<Tag relatedDocument={doc} theme={theme} />
  
    return (
      <div class="timeline-event">
       <div className="timeline-event-header">
          <div className="timeline-event-title">
            {icon} {eventTitle}
          </div>
           {time} {url}
        </div>
        {body}
      </div>
    )
  };

export default TimelineEvent;